import KunLoading58 from './src/index'

KunLoading58.install = function (Vue) {
	Vue.component(KunLoading58.name, KunLoading58);
}

export default KunLoading58;
